export default function ResultsWinsGoldIcon() {
  return (
    <svg
      width='16'
      height='12'
      viewBox='0 0 16 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.7794 6.80518H6.22C6.01339 6.80518 5.8457 6.97286 5.8457 7.17947V11.3755C5.8457 11.5054 5.91308 11.6261 6.02387 11.6944C6.13466 11.7626 6.2727 11.7683 6.38858 11.7096L7.99955 10.8964L9.61051 11.7096C9.66381 11.7366 9.7216 11.7498 9.7791 11.7498C9.84737 11.7498 9.91534 11.7312 9.97523 11.6944C10.086 11.6261 10.1534 11.5057 10.1534 11.3755V7.17947C10.1534 6.97286 9.98571 6.80518 9.7791 6.80518H9.7794Z'
        fill='url(#paint0_linear_61_4915)'
      />
      <path
        d='M14.9486 3.24561H10.1184C9.91182 3.24561 9.74414 3.41329 9.74414 3.6199V5.25362C9.74414 5.46024 9.91182 5.62792 10.1184 5.62792H13.3149C14.4222 5.62792 15.3229 4.72722 15.3229 3.6199C15.3229 3.41329 15.1553 3.24561 14.9486 3.24561Z'
        fill='url(#paint1_linear_61_4915)'
      />
      <path
        d='M14.0053 4.87964H9.17508C8.96847 4.87964 8.80078 5.04732 8.80078 5.25393V6.88766C8.80078 7.09427 8.96847 7.26195 9.17508 7.26195H12.3716C13.4789 7.26195 14.3796 6.36125 14.3796 5.25393C14.3796 5.04732 14.2119 4.87964 14.0053 4.87964Z'
        fill='url(#paint2_linear_61_4915)'
      />
      <path
        d='M5.88223 3.24536H1.05203C0.845419 3.24536 0.677734 3.41305 0.677734 3.61966C0.677734 4.72697 1.57844 5.62768 2.68575 5.62768H5.88223C6.08884 5.62768 6.25653 5.45999 6.25653 5.25338V3.61966C6.25653 3.41305 6.08884 3.24536 5.88223 3.24536Z'
        fill='url(#paint3_linear_61_4915)'
      />
      <path
        d='M6.82529 4.87817H1.99539C1.78878 4.87817 1.62109 5.04586 1.62109 5.25247C1.62109 6.35978 2.5218 7.26049 3.62911 7.26049H6.82559C7.0322 7.26049 7.19989 7.0928 7.19989 6.88619V5.25247C7.19989 5.04586 7.0322 4.87817 6.82559 4.87817H6.82529Z'
        fill='url(#paint4_linear_61_4915)'
      />
      <path
        d='M7.99654 8.86418C10.3753 8.86418 12.3036 6.93583 12.3036 4.55709C12.3036 2.17835 10.3753 0.25 7.99654 0.25C5.6178 0.25 3.68945 2.17835 3.68945 4.55709C3.68945 6.93583 5.6178 8.86418 7.99654 8.86418Z'
        fill='url(#paint5_linear_61_4915)'
      />
      <path
        d='M10.2931 4.63384C10.497 4.41196 10.5634 4.10833 10.47 3.82147C10.3769 3.53461 10.1448 3.328 9.84929 3.26841L9.12525 3.12229C9.10369 3.1178 9.08513 3.10462 9.07435 3.08546L8.71173 2.44197C8.56381 2.17937 8.29522 2.02246 7.99398 2.02246C7.69275 2.02246 7.42416 2.17937 7.27624 2.44197L6.91362 3.08576C6.90284 3.10492 6.88427 3.1184 6.86271 3.12259L6.13868 3.26871C5.84313 3.3283 5.61107 3.53521 5.51795 3.82177C5.42482 4.10863 5.491 4.41226 5.69491 4.63414L6.19497 5.17792C6.20994 5.19409 6.21683 5.21595 6.21444 5.23751L6.1297 5.97142C6.09496 6.27086 6.22012 6.55562 6.46387 6.73259C6.60849 6.83769 6.77648 6.89129 6.94626 6.89129C7.06244 6.89129 7.17982 6.86614 7.29121 6.81523L7.96284 6.50771C7.98291 6.49873 8.00566 6.49873 8.02572 6.50771L8.69736 6.81523C8.97134 6.9407 9.28066 6.90986 9.5247 6.73259C9.76874 6.55532 9.89361 6.27086 9.85887 5.97142L9.77413 5.23751C9.77174 5.21565 9.77862 5.19409 9.7936 5.17792L10.2937 4.63414L10.2931 4.63384Z'
        fill='url(#paint6_linear_61_4915)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_61_4915'
          x1='7.99949'
          y1='11.7279'
          x2='7.99949'
          y2='6.90005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFCC1E' />
          <stop offset='1' stopColor='#FF9500' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_61_4915'
          x1='11.9902'
          y1='4.43676'
          x2='14.1318'
          y2='4.43676'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_61_4915'
          x1='11.7574'
          y1='6.0708'
          x2='13.3786'
          y2='6.0708'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_61_4915'
          x1='4.38505'
          y1='4.43652'
          x2='1.56197'
          y2='4.43652'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_61_4915'
          x1='5.18947'
          y1='6.06933'
          x2='2.56102'
          y2='6.06933'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_61_4915'
          x1='7.99654'
          y1='8.89502'
          x2='7.99654'
          y2='0.756047'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFBD00' />
          <stop offset='1' stopColor='#FFF065' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_61_4915'
          x1='7.99398'
          y1='6.86973'
          x2='7.99398'
          y2='2.11588'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9500' />
          <stop offset='1' stopColor='#FFCC1E' />
        </linearGradient>
      </defs>
    </svg>
  );
}
